import { GradeFeatureLabelCodes } from "../../../../common-deprecated/types/TexusTypes";
import { useCarConfigSelector } from "../redux/store";
import type {
    AphCarInfoModalReturnType,
    FeatureWithMissingAssets,
    FeatureWithMissingLabels,
} from "../utils/types/DebugModalTypes";
import type { StatusEntryType } from "../../../../common-deprecated/components/modals/status/StatusModalEntry";

const useAphCarInfoModal = (): AphCarInfoModalReturnType => {
    const gradeFeatures =
        useCarConfigSelector((state) => state.grades.items.find((grade) => grade.id === state.car.grade.id))
            ?.gradeFeatures || [];

    const validFeatures = gradeFeatures?.filter((feature) => feature.valid);
    const allFeaturesHaveLabels = !!gradeFeatures?.every(
        (feature) => feature.name && feature.subtitle && feature.description,
    );
    const allFeaturesHaveAssets = !!gradeFeatures?.every((feature) => !!feature.assets?.length);
    const featuresWithoutAssets = gradeFeatures?.filter((feature) => !feature.assets?.length) || [];
    const featuresWithMissingAssets: FeatureWithMissingAssets[] =
        gradeFeatures
            ?.filter((feature) => feature.assets?.length < 3)
            .map(({ id, name, assets }) => ({
                id,
                name,
                "GRADE_FEATURES-1": assets.find(({ type }) => type === "GRADE_FEATURES-1") || false,
                "GRADE_FEATURES-2": assets.find(({ type }) => type === "GRADE_FEATURES-2") || false,
                "GRADE_FEATURES-3": assets.find(({ type }) => type === "GRADE_FEATURES-3") || false,
            })) || [];
    const featuresWithMissingLabels: FeatureWithMissingLabels[] =
        gradeFeatures
            ?.filter((feature) => !feature.name || !feature.subtitle || !feature.description)
            .map(({ id, name, description, learnMore, subtitle }) => ({
                id,
                [GradeFeatureLabelCodes.ShortName]: name || false,
                [GradeFeatureLabelCodes.Title]: subtitle || false,
                [GradeFeatureLabelCodes.Description]: description || false,
                [GradeFeatureLabelCodes.LearnMore]: learnMore || false,
            })) || [];

    const entries: StatusEntryType[] = [
        {
            title: "Highlights",
            description: "Highlights are shown when all flags below are true.",
            values: [
                {
                    label: "Highlights are being returned",
                    value: `${gradeFeatures?.length || 0}`,
                },
                {
                    label: "All Highlights have labels",
                    value: allFeaturesHaveLabels,
                },
                {
                    label: "All Highlights have assets",
                    value: allFeaturesHaveAssets,
                },
                {
                    label: `Valid Highlights: ${validFeatures.length}/${gradeFeatures.length || 0}`,
                    collapsibleContent: JSON.stringify(validFeatures, undefined, 2),
                },
                {
                    label: `Highlights without assets: ${featuresWithoutAssets.length}/${gradeFeatures.length || 0}`,
                    collapsibleContent: JSON.stringify(featuresWithoutAssets, undefined, 2),
                },
                {
                    label: `Highlights with missing assets: ${featuresWithMissingAssets.length}/${
                        gradeFeatures.length || 0
                    }`,
                    collapsibleContent: JSON.stringify(featuresWithMissingAssets, undefined, 2),
                },
                {
                    label: `Highlights with missing labels: ${featuresWithMissingLabels.length}/${
                        gradeFeatures.length || 0
                    }`,
                    collapsibleContent: JSON.stringify(featuresWithMissingLabels, undefined, 2),
                },
            ],
        },
    ];

    return {
        entries,
    };
};

export default useAphCarInfoModal;
